// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const DAEWOONG_BIO_FIELD_ALIASES = {
  customerName: ['판매처명'],
  drugName: ['자재명'],
  unitPrice: ['단가'],
  quantity: ['검수수량'],
  prescriptionAmount: ['매출액'],
  feeRate: ['수수료율'],
  settlementAmount: ['수수료금액'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '회사코드',
  '처리년월',
  '처방유형',
  '영업지역',
  '영업그룹',
  '담당자명',
  '대표도매상',
  '대표도매상사업자번호',
  '대표도매상명',
  '판매처',
  '시퀀스',
  '구분',
  '판매처사업자번호',
  '판매처명',
  '자재코드',
  '자재명',
  '수수료율',
  '단가',
  '수량',
  '검수수량',
  '매출액',
  '수수료금액',
  '비고',
];

const DAEWOONG_BIO_HEADER_ROW_INDEX = 1;
const DAEWOONG_BIO_DATA_START_INDEX = 2;

function isDaewoongBioProfile(profile) {
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader('지급현황') &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const daewoongBioTemplate = {
  id: 'daewoong-bio',
  name: '대웅바이오 템플릿',
  match(context) {
    return context.headerProfiles.some(isDaewoongBioProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isDaewoongBioProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[DAEWOONG_BIO_HEADER_ROW_INDEX] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(DAEWOONG_BIO_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(DAEWOONG_BIO_DATA_START_INDEX).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const customerName = cleanText(row[columnMap.customerName]);
      const drugName = cleanText(row[columnMap.drugName]);

      if (!customerName || !drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: DAEWOONG_BIO_DATA_START_INDEX + rowOffset,
        templateId: this.id,
        detectedPharmaceuticalCompany: '대웅바이오',
        customerName,
        drugCode: '',
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '대웅바이오',
      templateName: this.name,
    };
  },
};

export default daewoongBioTemplate;
